import AmeliproAccordion from './AmeliproAccordion';
import AmeliproAccordionGroup from './AmeliproAccordionGroup';
import AmeliproAccordionTemplate from './AmeliproAccordionTemplate';
import AmeliproBadge from './AmeliproBadge';
import AmeliproBreadcrumb from './AmeliproBreadcrumb';
import AmeliproBtn from './AmeliproBtn';
import AmeliproCallback from './AmeliproCallback';
import AmeliproCard from './AmeliproCard';
import AmeliproCarousel from './AmeliproCarousel';
import AmeliproCarouselItem from './AmeliproCarouselItem';
import AmeliproContentLayout from './AmeliproContentLayout';
import AmeliproCustomSelector from './AmeliproCustomSelector';
import AmeliproDialog from './AmeliproDialog';
import AmeliproDisclosure from './AmeliproDisclosure';
import AmeliproErrorTemplate from './AmeliproErrorTemplate';
import AmeliproFilePreview from './AmeliproFilePreview';
import AmeliproFirstLogin from './AmeliproFirstLogin';
import AmeliproFilters from './AmeliproFilters';
import AmeliproHeader from './AmeliproHeader';
import AmeliproIcon from './AmeliproIcon';
import AmeliproIconBtn from './AmeliproIconBtn';
import AmeliproMenu from './AmeliproMenu';
import AmeliproMessage from './AmeliproMessage';
import AmeliproPageLayout from './AmeliproPageLayout';
import AmeliproPagination from './AmeliproPagination';
import AmeliproFooter from './AmeliproFooter';
import AmeliproPatientBanner from './AmeliproPatientBanner';
import AmeliproPaginationBtn from './AmeliproPaginationBtn';
import AmeliproPostalAddressField from './AmeliproPostalAddressField';
import AmeliproSelect from './AmeliproSelect';
import AmeliproStatus from './AmeliproStatus';
import AmeliproStepBtn from './AmeliproStepBtn';
import AmeliproStepper from './AmeliproStepper';
import AmeliproSwitch from './AmeliproSwitch';
import AmeliproTabBtn from './AmeliproTabBtn';
import AmeliproTable from './AmeliproTable';
import AmeliproTabs from './AmeliproTabs';
import AmeliproTextArea from './AmeliproTextArea';
import AmeliproTextField from './AmeliproTextField';
import AmeliproCheckboxGroup from './AmeliproCheckboxGroup';
import AmeliproTooltips from './AmeliproTooltips';
import AmeliproTransmission from './AmeliproTransmission';
import AmeliproUpload from './AmeliproUpload';
import ServiceMenu from './ServiceMenu';
import StructureMenu from './StructureMenu';
import StructureTabs from './StructureTabs';
import UserMenu from './UserMenu';

export const elements = {
	AmeliproAccordion,
	AmeliproAccordionGroup,
	AmeliproAccordionTemplate,
	AmeliproBadge,
	AmeliproBreadcrumb,
	AmeliproBtn,
	AmeliproCallback,
	AmeliproCard,
	AmeliproCarousel,
	AmeliproCarouselItem,
	AmeliproCheckboxGroup,
	AmeliproContentLayout,
	AmeliproCustomSelector,
	AmeliproDialog,
	AmeliproDisclosure,
	AmeliproErrorTemplate,
	AmeliproFilePreview,
	AmeliproFilters,
	AmeliproFirstLogin,
	AmeliproFooter,
	AmeliproHeader,
	AmeliproIcon,
	AmeliproIconBtn,
	AmeliproMessage,
	AmeliproMenu,
	AmeliproPageLayout,
	AmeliproPagination,
	AmeliproPaginationBtn,
	AmeliproPostalAddressField,
	AmeliproSelect,
	AmeliproTransmission,
	AmeliproTextField,
	AmeliproTooltips,
	AmeliproUpload,
	UserMenu,
	StructureMenu,
	StructureTabs,
	ServiceMenu,
	AmeliproTextArea,
	AmeliproPatientBanner,
	AmeliproStatus,
	AmeliproStepBtn,
	AmeliproStepper,
	AmeliproSwitch,
	AmeliproTabBtn,
	AmeliproTable,
	AmeliproTabs
};
